/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SmartRecommenderAPI
 * @hideconstructor
 *
 * @classdesc
 */
define([], () => {
	class SmartsRecommenderAPI {

		/**
		 * @function SmartsRecommenderAPI#recommendAlternateContent
		 * @description Recommend alternate contents
		 * @public
		 *
		 * @param {ContentAPI} content 
		 * @return {ContentAPI[]} list of alternate content
		 *
		 */
		recommendAlternateContent() {}

		/**
		 * @function SmartsRecommenderAPI#recommendRelatedContent
		 * @description Recommend related contents
		 * @public
		 *
		 * @param {ContentAPI} content 
		 * @return {ContentAPI[]} list of related content
		 *
		 */
		recommendRelatedContent() {}

	}

	return SmartsRecommenderAPI;
});
